var Template = {
    // takes innerHTML from the source, replaces all variables
    get: function (source, vars) {
        var html = jQuery(source).html();
        if (typeof(vars) !== 'undefined') {
            jQuery.each(vars, function (search, replacement) {
                html = html.replace(new RegExp("{{" + search + "}}", 'g'), replacement);
                html = html.replace(new RegExp("{" + search + "}", 'g'), replacement);
            });
        }
        return html;
    },

    // gets template and puts it to the dest
    put: function (source, dest, vars) {
        jQuery(dest).html(Template.get(source, vars));
    },

    popup: function (source, vars, options) {
        jQuery.colorbox.remove();
        options = jQuery.extend({}, options);
        options.html = Template.get(source, vars);
        options.maxWidth = '98%';
        options.trapFocus = false; //needed for clipboard.js
        options.fixed = true;

        jQuery.colorbox(options);

        setTimeout(function () {
            jQuery.colorbox.resize();
            applyAloomaTracking();
        }, 300);
    }
};

jQuery(function($) {
    // Handle pre-show colorbox
    function closePreShowColorbox(colorbox) {
        var colorboxOverlay = colorbox.prev("#cboxOverlay");
        colorbox.remove();
        colorboxOverlay.remove();
        jQuery(document).trigger('pre-show-popup-close');
    }

    var preShowColorbox = jQuery("#colorbox.pre-show");

    preShowColorbox.on('click', function(e) {
        e = e || window.event;
        var target = e.target || e.srcElement;
        if (target.id === "cboxWrapper") {
            closePreShowColorbox(jQuery(this));
        }
    });

    preShowColorbox.find("#cboxClose").on('click', function(e) {
        var colorbox = jQuery(this).closest("#colorbox");
        closePreShowColorbox(colorbox);
    });
});